// Mixin comum aos painéis de envolvido: props padronizadas + filtro de data.
export default {
  // Ocorrência finalizada: o card do envolvido (InvolvedClinicalCard) provê `occurrenceReadonly` e cada aba esconde
  // as suas ações de escrita com `v-if="!readonly"`. Sem o card (uso avulso) o padrão é editável.
  inject: {
    occurrenceReadonly: { default: () => () => false },
  },
  computed: {
    readonly() {
      return this.occurrenceReadonly()
    },
  },
  filters: {
    formatDate(val) {
      if (!val) return '—'
      const d = new Date(val)
      return d.toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
  // Os painéis ficam em <keep-alive>: ao voltar para a aba, recarrega os dados
  // (a primeira ativação logo após o mount não recarrega, o mounted já carregou).
  activated() {
    if (this.$_panelActivatedOnce && typeof this.refresh === 'function') this.refresh()
    this.$_panelActivatedOnce = true
  },
  props: {
    // Ocorrência atual.
    occurrenceId: { type: [Number, String], required: true },
    // Id do mestre (pessoa/veículo/...) — usado nas escritas clínicas.
    involvedId: { type: [Number, String], default: null },
    // Id da participação (occurrence_involveds.id) — usado no desfecho.
    occurrenceInvolvedId: { type: [Number, String], default: null },
    // Disciplina da ocorrência (filtra catálogos como desfechos).
    disciplineId: { type: [Number, String], default: null },
  },
}
